module.exports = __webpack_public_path__ + "img/taiwanHighSpeedRail-app.d40b94f1.jpg";